export default "__VITE_ASSET__B0r1aiaE__"